<template>
    <div>
        <b-modal
            ref="modalUsuario"
            size="lg" 
            no-close-on-esc
            no-close-on-backdrop
            scrollable
            id="modal-cadastro-usuario"
            :title="id ? 'Editar Usuário' : 'Criar um novo usuário'"
            @shown="openModal"
            @hide="fecharModal"
            >

            <el-form ref="formUsuario" v-loading="loadingForm" :model="model" :rules="rules" size="small" label-position="top" class="geral-form">
                <el-form-item label="Nome" prop="nome" required>
                    <el-input v-model="model.nome"></el-input>
                </el-form-item>
                <el-form-item label="Perfil" prop="regraDeAcessosFranqueadorId" required>
                    <div>
                    <el-select v-loading="loadingRegras" filterable clearable v-model="model.regraDeAcessosFranqueadorId" style="width:100%">
                        <el-option
                        v-for="item in optionsRegras"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    </div>
                </el-form-item>
                <el-form-item label="Email" prop="email" required>
                    <el-input v-model="model.email"></el-input>
                </el-form-item>

                <el-form-item v-if="!model._id" label="Senha" prop="password">
                    <el-input v-model="model.password" type="password" show-password required></el-input>
                </el-form-item>
                <el-form-item v-if="!model._id" label="Confirmar Senha" prop="passwordConfirmacao">
                    <el-input v-model="model.passwordConfirmacao" show-password required></el-input>
                </el-form-item>
                <el-form-item :label="model.isApproved ? 'Ativo' : 'Inativo'" prop="ativo">
                    <el-switch v-model="model.isApproved" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <div v-if="model._id">
                    <el-button size="mini" type="primary" @click="$parent.handleResetPassword(model)"><i class="fas fa-lock"></i> Redefinir senha</el-button>
                </div>
            </el-form>
            <div v-if="!model._id" class="forca-senha-content" v-show="model.password.length">
                <span>Força de senha:</span>
                <ul>
                <li :class="{ checked: minuscula }">- Conter ao menos 1 letra minúscula</li>
                <li :class="{ checked: maiuscula }">- Conter ao menos 1 letra maiúscula</li>
                <li :class="{ checked: numero }">- Conter ao menos 1 número</li>
                <li :class="{ checked: especial }">- Conter ao menos 1 caracter especial: <i>"! @@ # $ % & * ."</i></li>
                <li :class="{ checked: tamanho }">- Conter entre 8 a 16 caracteres</li>
                </ul>
            </div>
            <template #modal-footer="{ hide }">
                <div class="float-right">
                <el-button size="small" @click="hide()">Fechar</el-button>
                <el-button size="small" type="primary" @click="salvar">Salvar</el-button> 
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>

const model = (data) => {
    if(data) {
        return {
            _id: data._id,
            nome: data.nome,
            regraDeAcessosFranqueadorId: data.regraDeAcessosFranqueadorId,
            email: data.email,
            password: data.password,
            passwordConfirmacao: data.passwordConfirmacao,
            isApproved: data.isApproved
        }
    }
    return {
        _id: '',
        nome: '',
        regraDeAcessosFranqueadorId: '',
        email: '',
        password: '',
        passwordConfirmacao: '',
        isApproved: true
    }
}
export default {
    name: 'ModalUsuario',
    props: {
        id: {
            type: String,
            require: false
        }
    },
    data() {
        return {
            model: model(),
            loadingForm: false,
            loadingRegras: false,
            regras: [],
            rules: {
				nome: [{ required: true, message: 'Nome é um campo obrigatório!', trigger: 'blur' }],
				regraDeAcessosFranqueadorId: [{ required: true, message: 'Perfil é um campo obrigatório!', trigger: 'blur' }],
				email: [{ required: true, message: 'E-mail é um campo obrigatório!', trigger: 'blur' }],
                password: [{ required: true, message: 'Senha é um campo obrigatório!', trigger: 'blur' }],
				passwordConfirmacao: [{ required: true, message: 'Confirme sua senha!', trigger: 'blur' }]
			}
        }
    },
    computed: {
        optionsRegras () {
        const opts = this.regras.map(r => {
            return { value: r._id, text: r.nome }
        });

        return opts;
        },
        useEditSchema(){
            const {password, passwordConfirmacao} = this.model;
            return this.model._id && (!password.length && !passwordConfirmacao.length);
        },
        minuscula() {
            return /[a-z]/.test(this.model.password)
        },
        maiuscula() {
            return /[A-Z]/.test(this.model.password)
        },
        numero() {
            return /[0-9]/.test(this.model.password)
        },
        especial() {
            return /[!@#$%&*]/.test(this.model.password)
        },
        tamanho() {
            return this.model.password && this.model.password.length >= 8 && this.model.password.length <= 16
        },
    },
    methods: {
        // requests
        async getUsuario() {
            this.loadingForm = true;
            try {

                let response = await this.axios.get(`${this.$urls.GETONE_USER}?id=${this.id}`);

                if (response.status !== 200) {
                    return;
                }

                this.model = model(response.data);
            } catch (error) {
                console.error("Erro ao obter usuário:", error);
            } finally {
                this.loadingForm = false;
            }
        },
        async saveUsuario(formModel) {
            this.loadingForm = true;
            try {
                let response = this.model._id
                ?  await this.axios.put(this.$urls.EDITAR_USER, formModel)
                :  await this.axios.post(this.$urls.CRIAR_USER, this.model);

                if(response.status !== 200) {
                    this.$notify.error({
                        title: 'Obter detalhe',
                        message: `Não foi possível criar o usuário`,
                        position:'top-left'
                    });
                    return
                }

                this.fecharModal()
                this.$notify({
                    title: 'Sucesso',
                    message: `Usuário criado com sucesso`,
                    position:'top-left'
                });
                this.$parent.listarUsuarios();

            } catch(err) {
                this.$notify.error({
                    title: 'Erro interno',
                    message: err.response ? err.response.data : `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                    position:'top-left'
                });
            } finally {
                this.loadingForm = false
            }
        },
        salvar() {
            const ctx = this;
            ctx.$refs['formUsuario'].validate((valid) => {
                if (!valid) {
					ctx.$notify.error({
						title: 'Validação',
						message: `Por favor, preencha todos os campos obrigatórios`,
						position:'top-left'
					});
					return;
				}
                const modelClone = Object.assign({}, ctx.model);

                if(!ctx.model._id){
                    const regexPassword = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&.*]).{8,16}$/);
                    const { password, passwordConfirmacao} = modelClone;
                    if(!password || !passwordConfirmacao){
                        ctx.$notify.error({
                        title: 'Validação',
                        message: `Por favor, preencha os campos de senha`,
                        position:'top-left'
                        });
                        return;
                    }
                    if(password !== passwordConfirmacao){
                        ctx.$notify.error({
                        title: 'Validação',
                        message: `As senhas digitadas não coincidem`,
                        position:'top-left'
                        });
                        return;
                    }
                    if(!regexPassword.test(password)){
                        ctx.$notify.error({
                        title: 'Validação',
                        message: `A senha deve atender aos requisitos listados`,
                        position:'top-left'
                        });
                    }
                }else{
                    delete  modelClone.password;
                    delete  modelClone.passwordConfirmacao;
                }
                // salvar
                ctx.saveUsuario(modelClone);
            });
        },
        async listarRegrasDeAcessos () {
            this.loadingRegras = true
            try {
                const response = await this.axios.get(this.$urls.LISTAR_REGRAS_DE_ACESSOS);
                this.regras = response.data
            }catch (error) {
                console.log(error);
            }finally{
                this.loadingRegras = false
            }
        },
        openModal() {
            const _this = this
            if(!this.regras.length){
                this.listarRegrasDeAcessos()
            }
            if(_this.id) {
                _this.getUsuario();
                
                return
            }
            _this.model = model();
            
        },
        fecharModal() {
            this.model = model();
            this.$refs['formUsuario'].clearValidate();
            this.$bvModal.hide('modal-cadastro-usuario')
        }
    }
};
</script>
